const AudioPlayer = ({ audioUrl }: { audioUrl: string }) => {
    //const audioUrl = `/audio/${audioKey}`; // Endpoint URL

    return (
        <div>
            <audio controls src={audioUrl} >
                Your browser does not support the audio element.
            </audio>
        </div>
    );
};

export default AudioPlayer;
